// StatementsHeader.tsx — Sprint 13. The gradient banner with title +
// "Refresh" / "Send All (N)" actions. Stateless presentation.
// Sprint 140 (R13-1, ADR-135) — the left button was labelled "Generate", but
// statements are DERIVED server-side from fees: there is nothing to generate.
// It now refetches, which is what its ReloadOutlined icon always implied.
import React from 'react';
import { Button, Space, Typography } from 'antd';
import { FileTextOutlined, ReloadOutlined, SendOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export interface StatementsHeaderProps {
  draftCount: number;
  isSending:  boolean;
  onRefresh: () => void;
  onSendBulk: () => void;
}

export const StatementsHeader: React.FC<StatementsHeaderProps> = ({
  draftCount, isSending, onRefresh, onSendBulk,
}) => (
  <div style={{
    background: 'linear-gradient(135deg, #f8faff 0%, #eef2ff 100%)',
    border: '1px solid #e0e7ff',
    borderRadius: 12,
    padding: '20px 28px',
    marginBottom: 24,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
      <div style={{
        width: 48, height: 48,
        background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)',
        borderRadius: 12,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
      }}>
        <FileTextOutlined style={{ color: '#fff', fontSize: 22 }} />
      </div>
      <div>
        <Title level={4} style={{ margin: 0, color: '#1e1b4b', fontWeight: 700 }}>
          Financial Statements
        </Title>
        <Text style={{ color: '#6366f1', fontSize: 13 }}>
          Review, filter and distribute owner statements
        </Text>
      </div>
    </div>
    <Space>
      <Button icon={<ReloadOutlined />} onClick={onRefresh} style={{ borderRadius: 8, height: 38 }}>
        Refresh
      </Button>
      <Button
        type="primary"
        icon={<SendOutlined />}
        onClick={onSendBulk}
        loading={isSending}
        disabled={draftCount === 0}
        style={{ borderRadius: 8, height: 38, background: '#4f46e5', borderColor: '#4f46e5' }}
      >
        Send All ({draftCount})
      </Button>
    </Space>
  </div>
);
